"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShellsAlignmentDirections = exports.NodeType = exports.NodeAnimationTypeUiEnum = void 0;
var NodeAnimationTypeUiEnum;
(function (NodeAnimationTypeUiEnum) {
    NodeAnimationTypeUiEnum["NONE"] = "NONE";
    NodeAnimationTypeUiEnum["HOVER"] = "HOVER";
    NodeAnimationTypeUiEnum["IN_VIEW"] = "IN_VIEW";
    NodeAnimationTypeUiEnum["CONST"] = "CONST";
    NodeAnimationTypeUiEnum["TAP"] = "TAP";
})(NodeAnimationTypeUiEnum || (exports.NodeAnimationTypeUiEnum = NodeAnimationTypeUiEnum = {}));
var NodeType;
(function (NodeType) {
    NodeType["shell"] = "shell";
    NodeType["absolute"] = "absolute";
    NodeType["column"] = "column";
    NodeType["row"] = "row";
    NodeType["node"] = "node";
})(NodeType || (exports.NodeType = NodeType = {}));
var ShellsAlignmentDirections;
(function (ShellsAlignmentDirections) {
    ShellsAlignmentDirections["start"] = "start";
    ShellsAlignmentDirections["center"] = "center";
    ShellsAlignmentDirections["end"] = "end";
    ShellsAlignmentDirections["normal"] = "normal";
})(ShellsAlignmentDirections || (exports.ShellsAlignmentDirections = ShellsAlignmentDirections = {}));
